<p
	*ngIf="nextTimeLogin"
	[innerHTML]="'user-summary.desktop-session-limit-expired-next-time-login-message' | jurisdiction | translate: {nextTimeLogin}"
></p>
<p
	*ngIf="!nextTimeLogin"
	[innerHTML]="'user-summary.desktop-session-limit-expired-message' | jurisdiction | translate"
></p>
<p
	*ngIf="(sessionSummary$ | async) as sessionSummary"
	[innerHTML]="'session-summary.message' | translate: sessionSummary"
></p>
